import { render } from "./thanh-toan-bang-qrcode.vue?vue&type=template&id=543564b9"
import script from "./thanh-toan-bang-qrcode.vue?vue&type=script&lang=js"
export * from "./thanh-toan-bang-qrcode.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__